import { ScheduleParticipacionUser } from '@interfaces/userInterface';

type StatsRowProps = {
	user: ScheduleParticipacionUser;
};

const StatsRow = ({ user }: StatsRowProps) => (
	<div className="grid grid-cols-1 items-center gap-4 rounded-lg bg-white p-4 md:grid-cols-[3fr_repeat(6,1fr)_1fr]">
		<div>
			<div className="text-xs tracking-wide text-slate-500 uppercase md:hidden">Nom</div>
			<div className="truncate font-bold">{user.fullName}</div>
		</div>
		<div>
			<div className="text-xs tracking-wide text-slate-500 uppercase md:hidden">Responsable</div>
			<div>{user.responsable}</div>
		</div>
		<div>
			<div className="text-xs tracking-wide text-slate-500 uppercase md:hidden">Caissier</div>
			<div>{user.cashier}</div>
		</div>
		<div>
			<div className="text-xs tracking-wide text-slate-500 uppercase md:hidden">Opérateur</div>
			<div>{user.operator}</div>
		</div>
		<div>
			<div className="text-xs tracking-wide text-slate-500 uppercase md:hidden">Contrôleur</div>
			<div>{user.controller}</div>
		</div>
		<div>
			<div className="text-xs tracking-wide text-slate-500 uppercase md:hidden">Confiserie</div>
			<div>{user.store}</div>
		</div>
		<div>
			<div className="text-xs tracking-wide text-slate-500 uppercase md:hidden">3D</div>
			<div>{user.glasses}</div>
		</div>
		<div>
			<div className="text-xs tracking-wide text-slate-500 uppercase md:hidden">Total</div>
			<div className="font-bold">{user.total}</div>
		</div>
	</div>
);

export default StatsRow;
